import { memo, FC, SVGProps } from "react"

export const SidebarIcon: FC<SVGProps<SVGSVGElement>> = memo((props) => (
  <svg width="15" height="14" viewBox="0 0 15 14" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M13 0.150391C13.6904 0.150391 14.25 0.710035 14.25 1.40039V12.6504C14.25 13.3407 13.6904 13.9004 13 13.9004H1.25C0.559644 13.9004 0 13.3407 0 12.6504V1.40039C0 0.710035 0.559644 0.150391 1.25 0.150391H13ZM5.625 12.6504H13V1.40039H5.625V12.6504ZM1.25 12.6504H4.375V1.40039H1.25V12.6504Z" />
  </svg>
))
export default SidebarIcon
